<div *ngIf="notification" class="notification-container" [ngClass]="notification.type"
    [style.background-color]="themeData.secondarybg">
    <div class="notification-header">
        <span class="notification-type" [style.color]="themeData.secondarycolor">
            {{ notification.type | titlecase }}
        </span>
        <button class="close-btn" (click)="closeNotification()">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="notification-body">
        <p class="notification-message" [style.color]="themeData.secondarycolor">
            {{ notification.message }}
        </p>
    </div>
</div>